import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { injectIntl } from 'react-intl';

import { userIsAdmin } from '../../helpers/Auth';

class SharesHeader extends PureComponent {
  render() {
    const {
      intl,
      sharesVisible,
      sharesTotal,
      loading,
    } = this.props;

    return (
      <header className="page-header">
        <h2 className="page-title">
          <i className="far fa-share-alt" />
          {intl.formatMessage({ defaultMessage: '{isAdmin, select, yes {Share links} other {My Share links}}' }, { isAdmin: userIsAdmin() ? 'yes' : 'no' })}
        </h2>
        <div className="header-actions users-actions">
          <div className="items-displaying users-displaying">
            {(!loading && sharesTotal > 0) && (
              <span>
                {intl.formatMessage(
                  { defaultMessage: '{sharesVisible} of {sharesTotal} share links' },
                  { sharesVisible, sharesTotal },
                )}
              </span>
            )}
          </div>
        </div>
      </header>
    );
  }
}

SharesHeader.propTypes = {
  intl: PropTypes.object.isRequired,
  sharesVisible: PropTypes.string.isRequired,
  sharesTotal: PropTypes.number.isRequired,
  loading: PropTypes.bool.isRequired,
};

export default withRouter(injectIntl(SharesHeader));
